var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42944 7.9278L1.66797 16.4965L1.75204 18.8219C1.77028 19.3264 2.19429 19.713 2.67606 19.6644L5.80255 19.3486L5.62587 17.4431L7.45168 17.2587L7.275 15.3532L9.10082 15.1688L8.92414 13.2633L11.1151 13.042L12.4344 11.3701L8.42944 7.9278Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8944 9.79101C19.873 7.28359 19.5293 3.57695 17.1267 1.51199C14.7242 -0.552967 11.1726 -0.194283 9.19402 2.31313C7.21544 4.82055 7.55912 8.52719 9.96166 10.5921C12.3642 12.6571 15.9158 12.2984 17.8944 9.79101ZM16.3578 4.49626C16.788 3.95117 16.7133 3.14537 16.191 2.69647C15.6687 2.24757 14.8966 2.32554 14.4665 2.87063C14.0363 3.41572 14.1111 4.22151 14.6333 4.67042C15.1556 5.11932 15.9277 5.04135 16.3578 4.49626Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessManagement);
export default __webpack_public_path__ + "static/media/accessManagement.d266690aa49f71fcfa0620937c95904f.svg";
export { ForwardRef as ReactComponent };